import { ApiPropertyOptional } from '@nestjs/swagger';

import { SpConnectSummaryInterface } from '../interfaces/sp-connect-summary.interface';
import { IsOptional } from 'class-validator';

export class SpConnectSummaryDto implements SpConnectSummaryInterface {
  @ApiPropertyOptional({ type: 'number' })
  @IsOptional()
  taxAmount?: number;

  @ApiPropertyOptional({ type: 'number' })
  @IsOptional()
  orderTotal?: number;

  @ApiPropertyOptional({ type: 'number' })
  @IsOptional()
  numberOfLines?: number;

  @ApiPropertyOptional({ type: 'number' })
  @IsOptional()
  orderSubTotal?: number;
}
